import configs from '@returnmates/client-core/src/config'

export default configs()
